import {
    betslipStore,
} from '~SpectateStore';

import {
    selectCastMarketSelectionIds,
} from '~Betslip/selectors/userSelectionsSelectors';

import {
    GTP_BET_BUILDER_COMBINATION_TYPE,
} from '~Betslip/uiModes/shared/GTPBetBuilder/constants';

export const isSelectionSuspended = (selection) => {
    /**
     * Note: market_event_active/tradable flags come from BE markets_event table and are propogated via websocket
     * as market_active/tradable.
     */
    const {
        event_active,
        market_active,
        market_event_active,
        selection_active,
        event_tradable,
        market_event_tradable,
        selection_tradable,
        is_inplay,
        combination_type,
        ws_suspended,
    } = selection;

    if (combination_type === GTP_BET_BUILDER_COMBINATION_TYPE) {
        // Combinations have an error field, populated from BE when we add/remove selections.
        // WS induced errors are recorded in the ws_suspended field so we can "suspend" a
        // combination in a manner consistent with other selections

        return ws_suspended !== null && ws_suspended;
    }

    const isTradable = Boolean(is_inplay) === true
        ? Boolean(selection_tradable) && Boolean(event_tradable) && Boolean(market_event_tradable)
        : true;

    const isActive = Boolean(event_active) && Boolean(market_active) && Boolean(market_event_active) && Boolean(selection_active);

    return !isActive || !isTradable;
};

export const findFcTcSelectionId = (fcTcCombinationToValidate) => {
    const existingFcTcIds = selectCastMarketSelectionIds(betslipStore.getState());
    const toValidate = [...fcTcCombinationToValidate].sort().join('_');

    const fcTcSelectionId = existingFcTcIds.find((existingFcTcId) => {
        const sortedCombination = [...existingFcTcId].sort().join('_');

        return sortedCombination === toValidate;
    });

    return fcTcSelectionId ? fcTcSelectionId.join('_') : null;
};
